import { all, put, select, take } from 'redux-saga/effects';
import {
    PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR_SUCCESS,
    PRESUPUESTADOR_GET_PERITAJE_SUCCESS
} from '../constants';


export default function* clearBonificationTakingCar() {
    yield all([
        take(PRESUPUESTADOR_GET_PERITAJE_SUCCESS)
    ]);
    const { presupuestador } = yield select(state => state);
    
    if (presupuestador.entregaUsados?.length > 0) {
        const entregaUsadosClearBonifications = presupuestador.entregaUsados.map(usado => {
        usado.take_improvement_amount = 0;
        usado.final_take_price = usado.original_price;
          if(usado.appraisal_was_modified) {
            usado.final_take_price = usado.updatedTakePrice || usado.appraisal || usado.original_price;
          }
            return usado;
        });

        yield put({
            type: PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR_SUCCESS,
            data: { entregaUsados: entregaUsadosClearBonifications },
        })
    }
}
